











import Vue from "vue";
import {Expandable} from "@/componentsReusable/Expandable";

export default Vue.component('ExpandableRowItems', {
  props: {
    rows: {
      type: Array as () => Expandable[],
      required: true
    }
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/ExpandableRowItems.vue